module.exports = __webpack_public_path__ + "img/2.5d488cbb.jpg";